import { IconProps } from 'components/icons/Icons.types';
import React from 'react';
import styles from './Icon.module.scss';

const AddUserIcon: React.FC<IconProps> = ({
  className = '',
  size = 24,
  color = '#fffff0',
  fillColor = 'transparent',
  fillOpacity = 1,
  circleStrokeColor = '#fffff0',
}) => {
  const baseCls = `${styles.IconContainer} ${className}`;
  return (
    <div className={baseCls}>
      <svg width={size} height={size} viewBox="0 0 24 24" fill="transparent" xmlns="http://www.w3.org/2000/svg">
        <circle
          fill={fillColor}
          fillOpacity={fillOpacity}
          cx="12"
          cy="12"
          r="10.5"
          stroke={circleStrokeColor}
          strokeWidth={'1.5px'}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M9.15 11.18c1.49 0 2.7-1.21 2.7-2.7s-1.21-2.7-2.7-2.7-2.7 1.21-2.7 2.7 1.21 2.7 2.7 2.7Zm0-1.35c.75 0 1.35-.6 1.35-1.35s-.6-1.35-1.35-1.35-1.35.6-1.35 1.35.6 1.35 1.35 1.35Zm2.02 3.38c.37 0 .68.31.68.68v4.05h1.35v-4.05c0-1.12-.91-2.02-2.02-2.02H7.13c-1.12-.02-2.03.89-2.03 2.01v4.05H6.45v-4.05c0-.37.31-.68.68-.68h4.05ZM15.9 8.48h1.35v1.35h1.35v1.35H17.25v1.35H15.9v-1.35H14.55V9.83h1.35V8.48Z"
          fill={color}
        />
      </svg>
    </div>
  );
};

export default AddUserIcon;
